import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import ContactInfo from 'containers/VerticalPage/common/ContactInfo/ContactInfo'
import { tabsIds, getTabsList, overviewMapping } from './utils'
import Tabs from 'components/common/Tabs'
import Overview from '../Overview/Overview'
import BusinessActivity from '../BusinessActivity/BusinessActivity'
import DetailsWrapper from 'containers/VerticalPage/common/DetailsWrapper/DetailsWrapper'
import styles from 'containers/VerticalPage/common/styles.scss'
import GraphContainer from 'containers/VerticalPage/common/GraphContainer/GraphContainer'
import { selectCurrentZone } from 'store/global'
import type { CurrentZone } from 'utils/types'

const tabsList = getTabsList()

type ValidTabId = Exclude<(typeof tabsIds)[keyof typeof tabsIds], typeof tabsIds.TAX_RETURN>

type TabContent = {
  [key in ValidTabId]: JSX.Element
}

const Details = () => {
  const [activeTab, setActiveTab] = useState<ValidTabId>(tabsIds.OVERVIEW)
  const currentZone: CurrentZone = useSelector(selectCurrentZone)

  const handleTabClick = (event: React.SyntheticEvent<Element, Event>, value: number) => {
    if (value !== tabsIds.TAX_RETURN) {
      setActiveTab(value as ValidTabId)
    }
  }

  const contentByTabMap = useMemo<TabContent>(
    () => ({
      [tabsIds.OVERVIEW]: <Overview showGraph={false} />,
      [tabsIds.BUSINESS_ACTIVITY]: <BusinessActivity />,
      [tabsIds.CONTACT_INFO]: <ContactInfo />,
    }),
    [],
  )

  return (
    <DetailsWrapper>
      <div className={styles.tabsWrapper}>
        <Tabs
          tabs={tabsList}
          value={activeTab}
          disabledIds={[tabsIds.TAX_RETURN]}
          tabsClasses={{
            root: styles.root,
            flexContainer: styles.flexContainer,
          }}
          tabClasses={{
            root: styles.tabRoot,
            disabled: styles.tabDisabled,
          }}
          onChange={handleTabClick}
        />
        {currentZone?.influencersGraphIndices && (
          <GraphContainer zone={currentZone.influencersGraphIndices} overviewMapping={overviewMapping} />
        )}
      </div>
      {contentByTabMap[activeTab]}
    </DetailsWrapper>
  )
}

export default Details
